"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getCoverDesignOptions;
const either_1 = require("../../types/either");
const constants_1 = require("./constants");
const isDesignAllowedForPageCount_1 = __importDefault(require("./isDesignAllowedForPageCount"));
function getCoverDesignOptions(templateDesigns, printableCount) {
  // We need to do this for everyday photo book, not sure if we'll need to for all spread books
  const coverDesigns = templateDesigns.filter(d => {
    const isFirstPageDesign = d.allowedPages === constants_1.FIRST;
    return isFirstPageDesign && ((0, isDesignAllowedForPageCount_1.default)(d, printableCount) || !printableCount);
  });
  return (0, either_1.right)(coverDesigns);
}